import * as requests from '../api-request'

export const character = async (data = {}, token) => requests.toJSON('POST', 'nolan/character', data, token)

export const drawScene = async (data = {}, token) => {
  return requests.toJSON('POST', 'nolan/draw_scene', data, token)
}

export const drawCharacter = async (data = {}, token) => {
  return requests.toJSON('POST', 'nolan/draw_character', data, token)
}

export const spellingGrammar = async (data, token) => {
  return requests.toJSON('POST', 'nolan/spelling_grammar', data, token)
}

export const changeAccent = async (data, token) => {
  return requests.toJSON('POST', 'nolan/change_accent', data, token)
}

export const startStory = async (data, token) => {
  return requests.toJSON('POST', 'nolan/start_story', data, token)
}

export const startEpisodicPilot = async (data, token) => {
  return requests.toJSON('POST', 'nolan/start_episodic_pilot', data, token)
}

export const extractElements = async (data, token) => {
  return requests.toJSON('POST', 'nolan/break_smart/extract_elements', data, token)
}

export const sceneTitle = async (data, token) => {
  return requests.toJSON('POST', 'nolan/break_smart/scene_title', data, token)
}

export const sceneDetails = async (data, token) => {
  return requests.toJSON('POST', 'nolan/break_smart/scene_details', data, token)
}

export const sceneSynopsis = async (data, token) => {
  return requests.toJSON('POST', 'nolan/break_smart/scene_synopsis', data, token)
}

export const sceneSummary = async (data, token) => {
  return requests.toJSON('POST', 'nolan/break_smart/scene_summary', data, token)
}

export const uniqLocations = async (data, token) => {
  return requests.toJSON('POST', 'nolan//break_smart/uniq_locations', data, token)
}

export const suggestScriptTitles = async (data, token) => {
  return requests.toJSON('POST', 'nolan/suggest_script_title', data, token)
}

export const exportGenres = async (data, token) => {
  return requests.toJSON('POST', 'nolan/export_genre', data, token)
}

export const exportSynopsis = async (data, token) => {
  return requests.toJSON('POST', 'nolan/export_synopsis', data, token)
}

export const countTokens = async (data, token) => {
  return requests.toJSON('POST', 'nolan/count_tokens', data, token)
}

export const countBeatSheetTokens = async (data, token, signal) => {
  return requests.toJSON('POST', 'nolan/beat_sheet/count_tokens', data, token, signal)
}

export const createSceneFromBeatSheet = async (data, token, signal) => {
  return requests.toJSON('POST', 'nolan/beat_sheet/create_scene', data, token, signal)
}

export const createVideoShort = async (data, token) => {
  return requests.toJSON('POST', 'nolan/video_short', data, token)
}

export const createSceneShots = async (data, token) => {
  return requests.toJSON('POST', 'nolan/create_scene_shots', data, token)
}

export const editSuggestion = async (data, token) => {
  return requests.toJSON('POST', 'nolan/edit_suggestion', data, token)
}

export const scriptDoctor = async (data, token) => {
  return requests.toJSON('POST', 'nolan/script_doctor', data, token)
}

// treatment
export const treatmentActOneOpening = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/act-one/opening', data, token)
}

export const treatmentActOneClosing = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/act-one/closing', data, token)
}

export const treatmentActTwoOpening = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/act-two/opening', data, token)
}

export const treatmentActTwoMidpoint = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/act-two/midpoint', data, token)
}

export const treatmentActTwoClosing = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/act-two/closing', data, token)
}

export const treatmentActThree = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/act-three', data, token)
}

// pilot treatment

export const pilotTreatmentTeaser = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/create', data, token)
}

export const pilotTreatmentActOne = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/act-one', data, token)
}

export const pilotTreatmentActTwo = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/act-two', data, token)
}

export const pilotTreatmentActThree = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/act-three', data, token)
}

export const pilotTreatmentActFour = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/act-four', data, token)
}

export const pilotTreatmentActFive = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/act-five', data, token)
}

export const pilotTreatmentTag = async (data, token) => {
  return requests.toJSON('POST', 'nolan/treatment/pilot/tag', data, token)
}

export const resolveCast = async (data = {}, token) => requests.toJSON('POST', 'nolan//break_smart/resolve_cast', data, token)
